/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProposalValidationSettingsUpdateRequest
 */
export interface ProposalValidationSettingsUpdateRequest {
    /**
     * 
     * @type {number}
     * @memberof ProposalValidationSettingsUpdateRequest
     */
    administratorValidationThreshold?: number;
}

/**
 * Check if a given object implements the ProposalValidationSettingsUpdateRequest interface.
 */
export function instanceOfProposalValidationSettingsUpdateRequest(value: object): value is ProposalValidationSettingsUpdateRequest {
    return true;
}

export function ProposalValidationSettingsUpdateRequestFromJSON(json: any): ProposalValidationSettingsUpdateRequest {
    return ProposalValidationSettingsUpdateRequestFromJSONTyped(json, false);
}

export function ProposalValidationSettingsUpdateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProposalValidationSettingsUpdateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'administratorValidationThreshold': json['administratorValidationThreshold'] == null ? undefined : json['administratorValidationThreshold'],
    };
}

export function ProposalValidationSettingsUpdateRequestToJSON(value?: ProposalValidationSettingsUpdateRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'administratorValidationThreshold': value['administratorValidationThreshold'],
    };
}

